import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'
import { getBuildEnvFromDomain, getSentryTracesSampleRate, getSentryProfilesSampleRate } from './services/utils'

if (process.env.REACT_APP_ENABLE_SENTRY === 'true') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.browserProfilingIntegration()
    ],

    environment: getBuildEnvFromDomain(),
    release: process.env.REACT_APP_VERSION,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: getSentryTracesSampleRate(),
    ignoreErrors: [
      'ResizeObserver',
      'chrome-extension',
      'safari-web-extension',
      'moz-extension',
      'perceived.lobby.load'
    ],

    profilesSampleRate: getSentryProfilesSampleRate(),

    beforeSendTransaction: event => {
      // Filter failed transactions so they don't mess up the data.
      if (
        event.transaction === 'perceived.lobby.load' &&
        event?.contexts?.trace?.status !== 'ok' &&
        event?.contexts?.trace?.status !== undefined
      ) {
        return null
      }
      return event
    }
  })

  window.perceivedLobbyLoadPromisePending = true
  window.perceivedLobbyLoadPromise = new Promise((resolve, reject) => {
    window.perceivedLobbyLoadPromiseResolve = () => {
      if (window.perceivedLobbyLoadPromisePending) {
        window.perceivedLobbyLoadPromisePending = false
        resolve()
      }
    }
    window.perceivedLobbyLoadPromiseReject = () => {
      if (window.perceivedLobbyLoadPromisePending) {
        window.perceivedLobbyLoadPromisePending = false
        reject('perceived.lobby.load stopped')
      }
    }
  })

  // Only measure home page performance with this transaction.
  // Check for "/" as the root url will resolve into {locale}/casino/lobby
  if (window.location.pathname.endsWith('/casino/lobby') || window.location.pathname === '/') {
    Sentry.startSpan(
      {
        name: 'perceived.lobby.load',
        forceTransaction: true
      },
      async () => await window.perceivedLobbyLoadPromise
    ).catch(() => {
      // Swallow promise rejection.
    })
  }
}
